/**
 * Constantes DGII según Norma 07-18
 */

// Tabla de Tipo de Bienes y Servicios (Códigos de Costos y Gastos)
export const TIPO_BIEN_SERVICIO = {
	'1': 'Gastos de Personal',
	'2': 'Gastos por Trabajos, Suministros y Servicios',
	'3': 'Arrendamientos',
	'4': 'Gastos de Activos Fijos',
	'5': 'Gastos de Representación',
	'6': 'Otras Deducciones Admitidas',
	'7': 'Gastos Financieros',
	'8': 'Gastos Extraordinarios',
	'9': 'Compras y Gastos que Formarán Parte del Costo de Venta',
	'10': 'Adquisiciones de Activos',
	'11': 'Gastos de Seguros',
};

export const TIPO_BIEN_SERVICIO_OPTIONS = Object.entries(TIPO_BIEN_SERVICIO).map(([value, label]) => ({
	value,
	label: `${value} - ${label}`
}));

// Tabla de Forma de Pago
export const FORMA_PAGO = {
	'1': 'Efectivo',
	'2': 'Cheques/Transferencias/Depósito',
	'3': 'Tarjeta Crédito/Débito',
	'4': 'Compra a Crédito',
	'5': 'Permuta',
	'6': 'Notas de Crédito',
	'7': 'Mixto',
};

export const FORMA_PAGO_OPTIONS = Object.entries(FORMA_PAGO).map(([value, label]) => ({
	value,
	label: `${value} - ${label}`
}));

// Tabla de Tipo de Retención ISR
export const TIPO_RETENCION_ISR = {
	'1': 'Alquileres',
	'2': 'Honorarios por Servicios',
	'3': 'Otras Rentas',
	'4': 'Otras Rentas (Rentas Presuntas)',
	'5': 'Intereses Pagados a Personas Jurídicas Residentes',
	'6': 'Intereses Pagados a Personas Físicas Residentes',
	'7': 'Retención por Proveedores del Estado',
	'8': 'Juegos Telefónicos',
};

export const TIPO_RETENCION_ISR_OPTIONS = Object.entries(TIPO_RETENCION_ISR).map(([value, label]) => ({
	value,
	label: `${value} - ${label}`
}));

// Orden de columnas según formato 606 oficial
export const FORMATO_606_COLUMNAS = [
	{ key: 'rnc_emisor', label: 'RNC/Cédula', width: 120 },
	{ key: 'tipo_id', label: 'Tipo ID', width: 80 },
	{ key: 'tipo_bien_servicio', label: 'Tipo Bien/Servicio', width: 150 },
	{ key: 'ncf', label: 'NCF', width: 130 },
	{ key: 'ncf_modificado', label: 'NCF Modificado', width: 150 },
	{ key: 'fecha_comprobante', label: 'Fecha Comprobante', width: 140 },
	{ key: 'fecha_pago', label: 'Fecha Pago', width: 120 },
	{ key: 'monto_facturado_servicios', label: 'Monto Servicios', width: 130 },
	{ key: 'monto_facturado_bienes', label: 'Monto Bienes', width: 130 },
	{ key: 'monto_facturado', label: 'Total Facturado', width: 130 },
	{ key: 'descuento', label: 'Descuento', width: 100 },
	{ key: 'itbis_facturado', label: 'ITBIS Facturado', width: 130 },
	{ key: 'itbis_retenido', label: 'ITBIS Retenido', width: 130 },
	{ key: 'itbis_proporcionalidad', label: 'ITBIS Proporcionalidad', width: 160 },
	{ key: 'itbis_llevado_costo', label: 'ITBIS Costo', width: 130 },
	{ key: 'itbis_por_adelantar', label: 'ITBIS Adelantar', width: 130 },
	{ key: 'itbis_percibido_compras', label: 'ITBIS Percibido', width: 140 },
	{ key: 'tipo_retencion_isr', label: 'Tipo Ret. ISR', width: 120 },
	{ key: 'monto_retencion_renta', label: 'Monto Ret. Renta', width: 140 },
	{ key: 'isr_percibido_compras', label: 'ISR Percibido', width: 130 },
	{ key: 'impuesto_selectivo_consumo', label: 'Imp. Selectivo', width: 130 },
	{ key: 'otros_impuestos_tasas', label: 'Otros Impuestos', width: 130 },
	{ key: 'monto_propina_legal', label: 'Propina Legal', width: 120 },
	{ key: 'forma_pago', label: 'Forma Pago', width: 120 },
];

// Mapeo de textos comunes a códigos DGII
const MAPEO_TEXTO_TIPO_BIEN_SERVICIO = {
	'combustible': '9',
	'combustibles': '9',
	'repuesto': '9',
	'repuestos': '9',
	'servicio': '2',
	'servicios': '2',
	'bien': '9',
	'bienes': '9',
	'personal': '1',
	'arrendamiento': '3',
	'activo': '10',
	'activos': '10',
	'seguro': '11',
	'seguros': '11'
};

// Normalizar código de tipo bien/servicio (convertir texto a código si es necesario)
export const normalizarCodigoTipoBienServicio = (valor) => {
	if (!valor && valor !== 0 && valor !== '0') return null;
	
	const valorStr = valor.toString().trim();
	
	// Si es un número o string numérico, retornarlo directamente
	if (/^\d+$/.test(valorStr)) {
		return valorStr;
	}
	
	// Si viene como "1 - Gastos de Personal", extraer solo el código
	const match = valorStr.match(/^(\d+)\s*-/);
	if (match) {
		return match[1];
	}
	
	// Intentar mapear el texto a un código
	const textoLower = valorStr.toLowerCase();
	if (MAPEO_TEXTO_TIPO_BIEN_SERVICIO[textoLower]) {
		return MAPEO_TEXTO_TIPO_BIEN_SERVICIO[textoLower];
	}
	
	// Si contiene alguna palabra clave, mapearla
	for (const [palabra, codigo] of Object.entries(MAPEO_TEXTO_TIPO_BIEN_SERVICIO)) {
		if (textoLower.includes(palabra)) {
			return codigo;
		}
	}
	
	// Si no coincide con ningún patrón, retornar null
	return null;
};

// Función helper para obtener label de código
export const getTipoBienServicioLabel = (codigo) => {
	if (!codigo) return 'N/A';
	
	// Normalizar el código antes de usarlo
	const codigoNormalizado = normalizarCodigoTipoBienServicio(codigo);
	if (!codigoNormalizado) return 'N/A';
	
	return `${codigoNormalizado} - ${TIPO_BIEN_SERVICIO[codigoNormalizado] || 'Desconocido'}`;
};

// Mapeo texto → código DGII (Norma 07-18) para forma_pago cuando n8n envía texto
const MAPEO_TEXTO_FORMA_PAGO = {
	efectivo: '1', cash: '1',
	cheque: '2', transferencia: '2', depósito: '2', deposito: '2', transfer: '2',
	tarjeta: '3', visa: '3', master: '3', débito: '3', debito: '3', amex: '3',
	crédito: '4', credito: '4', 'compra a crédito': '4', 'a crédit': '4', 'a credit': '4',
	permuta: '5', trueque: '5', intercambio: '5',
	'nota de crédito': '6', 'notas de crédito': '6', 'nota crédito': '6', 'nota credito': '6',
	mixto: '7', combinado: '7',
};

// Normalizar código de forma de pago (extraer código si viene como "1 - Efectivo" o texto "Efectivo")
export const normalizarCodigoFormaPago = (valor) => {
	if (!valor && valor !== 0 && valor !== '0') return null;
	// Si es lista (n8n a veces envía ["Efectivo"]), tomar primer elemento
	if (Array.isArray(valor)) valor = valor[0];
	if (!valor && valor !== 0 && valor !== '0') return null;
	
	const valorStr = valor.toString().trim();
	
	// Si es un número o string numérico (1-7), retornarlo directamente
	if (/^[1-7]$/.test(valorStr) || /^0?[1-7]$/.test(valorStr)) {
		return valorStr.replace(/^0/, '');
	}
	
	// Si viene como "1 - Efectivo" o "1-Efectivo", extraer solo el código
	const match = valorStr.match(/^(\d+)\s*-/);
	if (match) {
		return match[1];
	}
	
	// Si n8n envió texto (ej. "Efectivo"), mapear a código DGII
	const v = valorStr.toLowerCase();
	for (const [texto, codigo] of Object.entries(MAPEO_TEXTO_FORMA_PAGO)) {
		if (v.includes(texto)) return codigo;
	}
	
	// Si viene como objeto con propiedades value o codigo
	if (typeof valor === 'object' && valor !== null) {
		if (valor.value) return normalizarCodigoFormaPago(valor.value);
		if (valor.codigo) return normalizarCodigoFormaPago(valor.codigo);
	}
	
	return null;
};

export const getFormaPagoLabel = (codigo) => {
	if (!codigo) return 'N/A';
	
	// Normalizar el código antes de usarlo
	const codigoNormalizado = normalizarCodigoFormaPago(codigo);
	if (!codigoNormalizado) return 'N/A';
	
	return `${codigoNormalizado} - ${FORMA_PAGO[codigoNormalizado] || 'Desconocido'}`;
};

export const getTipoRetencionISRLabel = (codigo) => {
	return codigo ? `${codigo} - ${TIPO_RETENCION_ISR[codigo] || 'Desconocido'}` : 'N/A';
};

